import React from 'react';
import { Header } from './../Calculators/Header';
import { Intro } from './../Calculators/Intro';
import { ButtonPanel } from './../Calculators/ButtonPanel';
import { Centered, CalculatorSection } from './../Calculators/Sections';
import { Button, ButtonLink, TextInput, RadioButton, RangerInput } from './../Form/index';
import { LevelsOfEnhancement } from './LevelsOfEnhancement';
// import { Temperature } from './Temperature';
// import { MaxLoan } from './MaxLoan';
// import { FindOutMore } from './FindOutMore';
import { AskingQuestions } from './AskingQuestions';

const titleLtv = [
  // 'While your client might seem fit and healthy it’s always important to ask them our 13 health questions as their health',
  // 'can have a significant impact on the loan your client could qualify for. See how the amount your client could release',
  // 'changes depending on the severity of their health issues.'
];

const ClientDetails = ({ input, onChangeInput }) => (
  <CalculatorSection>
    <div className="title">Client Details</div>
    <div className="section-row">
      <div className="column radio-container">
        <RadioButton
            minWidth={130}
            value={true}
            checked={input.isJoint === false}
            onChange={() => onChangeInput('isJoint', false)}
          >
          <div className="label">Single life</div>
        </RadioButton>
        <RadioButton
          value={false}
          checked={input.isJoint === true}
          onChange={() => onChangeInput('isJoint', true)}
        >
          <div className="label">Joint life</div>
        </RadioButton>
      </div>
    </div>
    <div className="section-row">
      <div className="column">
        <div className="label">Age (youngest if couple)</div>
        <div style={{ paddingTop: 10 }}>
          <RangerInput
            value={input.clientAge} min={(input.isJoint) ? 56 : 55} max={95} withLabel={true}
            color='#209546' inactiveColor='#bbbbbb'
            onChange={val => { onChangeInput('clientAge', val) }}
          />
        </div>
      </div>
      <div className="small-column">
        <div className="label">Value of Home</div>
        <div>
          <TextInput
            width={150}
            type="currency" prefixes="&pound;" value={input.housePrice} onChange={val => { onChangeInput('housePrice', val) }} />
        </div>
      </div>
    </div>
  </CalculatorSection>
);

export const LtvCalculatorComponent = (props) => {
  const { screen, partialRepayment, onChangeInput, onChangePlan } = props;
  const { match } = props
  const hideLink = match && match.params && parseInt(match.params.Id, 10) === 1;
  return (
    <div>
      <Header  {...screen} title={['Tailored enhanced LTV calculator']}/>
      {screen.inFrame ? false : <Intro title={titleLtv} padding={20} />}
      <Centered>
        <ClientDetails {...partialRepayment} onChangeInput={onChangeInput} />
        <AskingQuestions  {...partialRepayment} hideLink={hideLink} />
        <LevelsOfEnhancement {...partialRepayment} onChangePlan={onChangePlan} />
        <p>Correct as @ Nov 2021</p>
      </Centered>

      {screen.inFrame ? false : (
        <ButtonPanel className="footer">
          <ButtonLink to='/' style={{ background: 'black' }}>Back</ButtonLink>
          <div style={{ flex: 1 }}></div>
          <Button disabled={true}>Download PDF Report</Button>
        </ButtonPanel>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/LtvCalculator/LtvCalculatorComponent.js